export enum TooltipVariants {
  CONVERSION = 'conversion'
}
